import * as USERS from './users.constants';
import { ApplicationUserViewModel } from '../../models';

/** LOAD */
export function loadUsers() {
    return { type: USERS.USERS_LOAD };
}

export function loadUsersSuccess(data: ApplicationUserViewModel[]) {
    return { type: USERS.USERS_LOAD_SUCCESS, payload: data };
}

export function loadUsersError(error: any) {
    return { type: USERS.USERS_LOAD_ERROR, payload: error };
}